import TaskDialog from "../../../../components/TaskDialog"
import { getEditorData, useNodeUtils } from "../../utils"

export default function TaskNodeEditor({ open, onClose, node }) {
  const { updateNodeEditorData } = useNodeUtils()

  function handleTaskDialogClosed(task) {
    if (task) {
      updateNodeEditorData(node, task)
    }
    onClose()
  }

  return (
    <TaskDialog
      open={open}
      onClose={handleTaskDialogClosed}
      task={getEditorData(node)}
      workflowMode
    />
  )
}
